var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('preloader',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.preloader),expression:"this.$store.state.preloader"}]}),_vm._v(" "),_c('bounce',{directives:[{name:"show",rawName:"v-show",value:(this.$store.state.bounce),expression:"this.$store.state.bounce"}]}),_vm._v(" "),_c('router-view',{class:_vm.$store.state.showCart?'my-body-noscroll-class':''})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac26608e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 74
// module chunks = 23